import { getSignedUrlByKeyAsync } from "api/document";

/**
 * Get a presigned GET URL for a user-doc object via the an-api backend (no
 * direct AWS access in the browser). The backend builds the key from
 * `cognito_id`/`filename` and returns a short-lived signed URL.
 * @param {string} filename
 * @param {string} cognito_id
 * @param {number} [expiresInSeconds=900]
 * @returns {Promise<string>} the signed URL
 */
export const getS3SignedUrl = async (filename, cognito_id, expiresInSeconds = 900) => {
  const response = await getSignedUrlByKeyAsync({
    cognitoId: cognito_id,
    filename,
    expiresInSeconds,
  });
  const url = response.data?.url;
  if (!url) {
    throw new Error("getS3SignedUrl: response did not contain a signed url");
  }
  return url;
};
